module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBmaWxsPSJub25lIiB2ZXJzaW9uPSIxLjEiIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDgwIDgwIj48Zz48cGF0aCBkPSJNMCwwTDgwLDgwTDgwLDE2QzgwLDcuMTYzNDQsNzIuODM2NiwwLDY0LDBMMCwwWiIgZmlsbD0iIzMwOTJFRCIgZmlsbC1vcGFjaXR5PSIxIi8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paySystem/bg_discount_blue.svg
// module id = 2Oo/
// module chunks = 1